import { LocalDealer } from '../logic/dealer/local-dealer';
import { LocalRoundResultSubmitter } from '../../common/phaser/model/local-round-result-submitter';
import { LocalRoundParams, RoundParams } from '../../common/phaser/model/round-params';
import { BlocksListener } from '../game/blocks-listener';

export class BlocksLocalRoundParams extends LocalRoundParams {
  constructor(
    readonly dealer: LocalDealer,
    localRoundResultSubmitter: LocalRoundResultSubmitter,
    readonly logicVersion: number,
  ) {
    super(localRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(gameListener: BlocksListener, logicVersion: number): BlocksLocalRoundParams {
    return new BlocksLocalRoundParams(
      LocalDealer.makeRandom(logicVersion),
      new LocalRoundResultSubmitter(gameListener),
      logicVersion,
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is BlocksLocalRoundParams {
    return roundParams instanceof BlocksLocalRoundParams;
  }
}
